import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
  retrieveInitiative,
  selectInitiative,
} from '../../modules/initiatives.js';
import {
  retrieveFiles,
  selectFiles,
  selectIsSearching,
} from '../../modules/files.js';
import InitiativeFiles from '../../components/initiatives/InitiativeFiles.jsx';
import { selectProject } from '../../modules/projects.js';

const mapStateToProps = (state, ownProps) => ({
  initiative: selectInitiative(
    ownProps.initiativeId,
    ownProps.initiativeType
  )(state),
  files: selectFiles(state),
  isSearching: selectIsSearching(state),
  project: selectProject(ownProps.projectId)(state),
});

const mapDispatchToProps = (dispatch, ownProps) =>
  bindActionCreators(
    {
      retrieveInitiative: () =>
        retrieveInitiative(ownProps.initiativeType, ownProps.initiativeId),
      retrieveFiles: (projectId) =>
        retrieveFiles(
          projectId,
          ownProps.initiativeType,
          ownProps.initiativeId
        ),
    },
    dispatch
  );

function InitiativeFilesContainer({
  files,
  initiative,
  isSearching,
  retrieveFiles,
  retrieveInitiative,
}) {
  const [loading, setLoading] = useState(true);

  const projectId = initiative?.project?.id;

  useEffect(() => {
    retrieveInitiative();
  }, [retrieveInitiative]);

  useEffect(() => {
    if (!projectId) return;

    retrieveFiles(projectId).then(() => setLoading(false));
  }, [projectId, retrieveFiles]);

  return (
    <InitiativeFiles
      loading={loading}
      initiative={initiative}
      files={files}
      project={initiative?.project}
      isSearching={isSearching}
    />
  );
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(InitiativeFilesContainer);
